/**
 * @generated SignedSource<<fd1672f39fa425f2b85165ccec0ddd31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ParticipationStatus = "Absent" | "AbsentExcused" | "NotConfirmed" | "Participated";
import { FragmentRefs } from "relay-runtime";
export type participantPresenceCheck_ParticipantFragment$data = {
  readonly participationStatus: ParticipationStatus;
  readonly user: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"userAvatar_UserFragment">;
  } | null;
  readonly " $fragmentType": "participantPresenceCheck_ParticipantFragment";
};
export type participantPresenceCheck_ParticipantFragment$key = {
  readonly " $data"?: participantPresenceCheck_ParticipantFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"participantPresenceCheck_ParticipantFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "participantPresenceCheck_ParticipantFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userAvatar_UserFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "participationStatus",
      "storageKey": null
    }
  ],
  "type": "Participant",
  "abstractKey": null
};

(node as any).hash = "3afda61217503d46f1072795442f2050";

export default node;
